import React from 'react';
import BoxActionsPanel from './BoxActionsPanel';

const GroupBoxes = ({ box, isSelected }) => {
  return (
    <>
      <div style={{
        width: box.width,
        height: box.height,
        cursor: 'grab',
      }} />
      {/* Dégrouper se faisait depuis la top bar : le groupe sélectionné n'avait
          aucune section dans le panel de droite. Les viseurs (aperçu,
          formulaire, PDF) n'ont pas d'inspecteur, d'où le garde fromViewer. */}
      {!box?.fromViewer && isSelected && <BoxActionsPanel />}
    </>
  );
};

export default GroupBoxes;
